<template>
  <div v-if="locationState">
    <transition
      name="fade"
      mode="out-in"
    >

      <component
        v-if="selectComponent"
        :key="locationDetail.visibleItem"
        :is="selectComponent.component"
        v-bind="selectComponent.binding"
        v-on="selectComponent?.listeners || {}"
      ></component>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import LocationMenu from '../../components/Locations/Manage/LocationMenu.vue'

export default {
  name: 'LocationController',

  components: {
    LocationMenu,
  },

  props: {
    pageView: {
      type: String,
      default: 'locationDetail'
    }
  },

  data() {
    return {
      channelId: this.$route.params.channelId
        ? Number(this.$route.params.channelId)
        : 0,
      locationId: this.$route.params.locationId
        ? Number(this.$route.params.locationId)
        : 0,
      wPageView: null,
      selectComponent: null
    }
  },

  computed: {
    ...mapState('channelStore', ['channel']),
    ...mapState('locationStore', [
      'location',
      'locationDetail',
      'locationState',
    ]),
    ...mapState('optionStore', ['optionsPage']),
    ...mapState('spaceStore', ['spacesPage']),
  },

  async created() {
    this.setVisibleItem(this.$props.pageView)
  },

  mounted() {
    this.wPageView = this.$watch(() => this.$props.pageView, this.renderView, { immediate: true })
  },

  beforeDestroy() {
    // this.setVisibleItem('locationDetail')
    this.wPageView && this.wPageView()
    this.selectComponent = null
  },

  methods: {
    ...mapMutations('locationStore', ['setLocationDetail']),

    renderView(view = '') {
      switch (view) {
        case 'locationDetail':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Locations/LocationDetail.vue')
            }),
            binding: {},
            listeners: {}
          }
          break;

        case 'settings':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Locations/Manage/LocationSettings.vue')
            }),
            binding: {}
          }
          break;

        case 'openingHours':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Locations/Manage/OpeningHours/OpeningHours.vue')
            }),
            binding: {}
          }
          break;

        case 'description':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Locations/Manage/LocationDescription.vue')
            }),
            binding: {}
          }
          break;

        case 'images':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Locations/Manage/LocationImages.vue')
            }),
            binding: {}
          }
          break;

        case 'videos':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Locations/Manage/LocationVideos.vue')
            }),
            binding: {
              locationId: this.locationId,
              channelId: this.channelId
            }
          }
          break;

        case 'spaces':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Locations/Manage/SpaceController.vue')
            }),
            binding: {}
          }
          break;

        case 'options':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Options/OptionList.vue')
            }),
            binding: {
              locationId: this.locationId
            }
          }
          break;

        case 'accounts':
          this.selectComponent = {
            component: () => ({
              component: import('@/components/Locations/Manage/Accounts/ManageAccounts.vue')
            }),
            binding: {}
          }
          break;

        case 'vouchers':
          this.selectComponent = {
            component: () => ({
              // The component to load (should be a Promise)
              component: import('@/components/Vouchers/VouchersList.vue')
            }),
            binding: {}
          }
          break;

        case 'yield':
          this.selectComponent = {
            component: () => ({
              // The component to load (should be a Promise)
              component: import('@/components/Yield/YieldList.vue')
            }),
            binding: {
              locationId: this.locationId,
              channelId: this.channelId
            },
            listeners: {
              goToItem: this.setVisibleItem
            }
          }
          break;

        case 'subscriptions':
          this.selectComponent = {
            component: () => ({
              // The component to load (should be a Promise)
              component: import('@/components/Locations/Manage/LocationSubscriptions.vue')
            }),
            binding: {}
          }
          break;

        default:
          this.selectComponent = null
          break;
      }
      this.setVisibleItem(view)
    },

    setVisibleItem(item) {
      this.locationDetail.visibleItem = item
      this.setLocationDetail(this.locationDetail)
    },
  },
}
</script>
